import "./listreservations.css";
import { ReservationsList } from "src/Components";
import { Link } from "react-router-dom";
import { useState } from "react";

const Svg = ({ children, size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">{children}</svg>
);
const IcPlus    = () => <Svg><line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" /></Svg>;
const IcRefund  = () => <Svg><polyline points="1 4 1 10 7 10" /><path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10" /></Svg>;
const IcClose   = () => <Svg size={18}><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></Svg>;

const RefundModal = ({ setActiveModal }) => {
  const [orderId, setOrderId] = useState("");
  const [amount, setAmount] = useState("");
  const [confirmAmount, setConfirmAmount] = useState("");

  const setPrice = (p, set) => {
    const re = /^[\d.,]+$/;
    if (p === "" || re.test(p)) set(p);
  };

  const amountsMatch = amount && confirmAmount && amount === confirmAmount;
  const canSubmit = orderId && amountsMatch;

  return (
    <div className="rsv-modal-overlay" onClick={() => setActiveModal(false)}>
      <div className="rsv-modal" onClick={(e) => e.stopPropagation()}>
        <header className="rsv-modal__head">
          <div>
            <span className="rsv-modal__eyebrow rsv-modal__eyebrow--warn">Restricted action</span>
            <h3>Refund a reservation</h3>
          </div>
          <button className="rsv-icon-btn" onClick={() => setActiveModal(false)} aria-label="Close">
            <IcClose />
          </button>
        </header>
        <div className="rsv-modal__body">
          <p className="rsv-modal__text">
            Issue a refund against the original payment order. Please confirm the
            amount carefully — refunds cannot be reversed.
          </p>

          <label className="rsv-field">
            <span>Order ID</span>
            <input
              placeholder="370474703"
              value={orderId}
              onChange={(e) => setOrderId(e.target.value)}
            />
          </label>

          <div className="rsv-field-row">
            <label className="rsv-field">
              <span>Amount</span>
              <input
                placeholder="10000"
                value={amount}
                onChange={(e) => setPrice(e.target.value, setAmount)}
              />
            </label>
            <label className="rsv-field">
              <span>Confirm amount</span>
              <input
                placeholder="10000"
                value={confirmAmount}
                onChange={(e) => setPrice(e.target.value, setConfirmAmount)}
              />
            </label>
          </div>

          {amount && confirmAmount && !amountsMatch && (
            <span className="rsv-form-error">Amounts don't match.</span>
          )}
        </div>
        <footer className="rsv-modal__foot">
          <button className="rsv-btn rsv-btn--ghost" onClick={() => setActiveModal(false)}>Cancel</button>
          <button className="rsv-btn rsv-btn--danger" disabled={!canSubmit}>Refund</button>
        </footer>
      </div>
    </div>
  );
};

const ListReservations = () => {
  const [refundButtonDisplay, setRefundButtonDisplay] = useState(true);
  const [refundModal, setRefundModal] = useState(false);

  return (
    <div className="rsv-page">
      <header className="rsv-hero">
        <div>
          <span className="rsv-hero__eyebrow">Front office</span>
          <h1 className="rsv-hero__title">Reservations</h1>
          <p className="rsv-hero__sub">
            Search, review and manage every booking made at your property.
          </p>
        </div>
        <div className="rsv-hero__actions">
          <Link to="create" className="rsv-btn rsv-btn--primary">
            <IcPlus /> Room reservation
          </Link>
        </div>
      </header>

      <ReservationsList />

      {localStorage.getItem("userrole") === "SUPER_ADMIN" && refundButtonDisplay && (
        <>
          <button
            type="button"
            className="rsv-fab"
            onClick={() => setRefundModal(true)}
            title="Issue refund"
          >
            <IcRefund />
            <span>Refund</span>
            <span
              className="rsv-fab__close"
              onClick={(e) => { e.stopPropagation(); setRefundButtonDisplay(false); }}
              aria-label="Hide refund button"
            >
              <IcClose />
            </span>
          </button>
          {refundModal && <RefundModal setActiveModal={setRefundModal} />}
        </>
      )}
    </div>
  );
};

export default ListReservations;
